"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MemberHeader = _interopRequireDefault(require("./MemberHeader"));

var _MobxPageContent = _interopRequireDefault(require("../../shared/components/MobxPageContent"));

var _mobxReact = require("mobx-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContentHeader = _interopRequireDefault(require("../../gradifui/components/section/ContentHeader"));

var _CookieConsent = _interopRequireDefault(require("../../shared/components/CookieConsent"));

var _EphemeralBanner = _interopRequireDefault(require("../../shared/components/message/EphemeralBanner"));

var _IENotSupportedBanner = _interopRequireDefault(require("../../shared/components/message/IENotSupportedBanner"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MemberPageContent = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(MemberPageContent, _React$Component);

  var _super = _createSuper(MemberPageContent);

  function MemberPageContent() {
    _classCallCheck(this, MemberPageContent);

    return _super.apply(this, arguments);
  }

  _createClass(MemberPageContent, [{
    key: "render",
    value: function render() {
      var header = /*#__PURE__*/_react.default.createElement(_MemberHeader.default, {
        selected: this.props.selectedHeaderItem
      });

      var ephemeralBanner = this.props.ephemeralBanner;
      return /*#__PURE__*/_react.default.createElement(_MobxPageContent.default, {
        header: header,
        disclaimers: this.props.disclaimers
      }, /*#__PURE__*/_react.default.createElement(_IENotSupportedBanner.default, null), ephemeralBanner && /*#__PURE__*/_react.default.createElement(_EphemeralBanner.default, {
        bannerHeaderContentKey: ephemeralBanner.headerContentKey,
        bannerMessageContentKey: ephemeralBanner.messageContentKey,
        ctaLink: ephemeralBanner.ctaLink,
        ctaText: ephemeralBanner.ctaText,
        ctaOpenInNewTab: false,
        ctaVisible: false
      }), this.props.sectionName && /*#__PURE__*/_react.default.createElement(_ContentHeader.default, {
        name: this.props.sectionName
      }), this.props.children, /*#__PURE__*/_react.default.createElement(_CookieConsent.default, null));
    }
  }]);

  return MemberPageContent;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  selectedHeaderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  sectionName: _propTypes.default.string
}), _class2)) || _class;

var _default = MemberPageContent;
exports.default = _default;